export enum EnumContainerLinguagem {
  DOTNET = 0,
  REACTJS = 1,
  DELPHI = 2,
  PHP = 3,
  NODEJS = 4,
  STENCILJS = 5,
  JAVASCRIPT = 6,
  SINGLESPA = 7,
}

export enum EnumContainerTipo {
  PARCEL = 0,
  FRONTEND = 1,
  BACKEND = 2,
  BIBLIOTECA = 3,
  FULLSTACK = 4,
  WEBCOMPONENT = 5,
  ORQUESTRADOR = 6,
}

export enum EnumIntegracao {
  ONPREMISE = 'ONPREMISE',
  SAAS = 'SAAS',
}

export enum EnumBancoDeDados {
  MSSQL = 0,
  MONGODB = 1,
  MYSQL = 2,
  COSMOSDB = 3,
  STORAGE = 4,
}

export enum EnumMensageriaDirecao {
  PUBLICA = 0,
  CONSOME = 1,
  PUBLICACONSOME = 2,
}
